<template>
  <ap-dialog :mask="true" :title="title" customClass="price-group-dialog" :appendToBody="false" v-model="visibleSync"
    :destroyOnClose="true" draggable style="--ap-dialog-width: 600px; --ap-dialog-padding-primary: 0">
    <template v-if="displayType === 'confirm'">
      <div class="price-group price-group--text">
        <span class="price-group__msg" v-html="message"></span>
      </div>
      <div class="price-group__btns">
        <ap-button type="primary" size="small" @click="onMessageConfirm" v-show="showConfirmButton">
          {{ confirmButtonText }}</ap-button>
        <ap-button type="default" size="small" @click="onCancel" v-show="showConfirmButton">{{
          showCancelButton && !showConfirmButton ? 'OK' : cancelButtonText
        }}</ap-button>
      </div>
    </template>
    <template v-else>
      <PopupPriceGroupSelect ref="popupPriceGroupSelectRef" :type="type" :value="value" :priceGroupList="priceGroupList"
        v-model:selectedIndex="selectedIndex" @cancel="onCancel" @confirm="onConfirm"></PopupPriceGroupSelect>
    </template>
  </ap-dialog>
</template>
<script lang="ts"></script>
<script setup lang="ts">
import { computed, type PropType, ref } from 'vue'
import PopupPriceGroupSelect from './PopupPriceGroupSelect'
import { ApDialog, ApButton } from '@anypromo/components-pc'
import { type PriceGroupCallback } from './types'
import { defaultProps } from './PopupPriceGroup'
import { useOrder } from "../../composables/use-order"

const props = defineProps({
  ...defaultProps,
  visible: {
    type: Boolean,
    default: true
  },
  callback: Function as PropType<(data?: PriceGroupCallback) => void>
})
const orderState = useOrder();
const emit = defineEmits(['update:visible', 'confirm', 'cancel'])

const popupPriceGroupSelectRef = ref(typeof PopupPriceGroupSelect)
const selectedIndex = ref(-1)

const updateShow = (show: boolean) => emit('update:visible', show)
const visibleSync = computed({
  get () {
    return props.visible
  },
  set (val: boolean) {
    updateShow(val)
  }
})
const onCancel = () => {
  emit('cancel')
  updateShow(false)
}

const onMessageConfirm = () => {
  const param: PriceGroupCallback = {
    type: props.type,
    value: props.value,
    reasonCode: props.reasonCode,
    updateBlankValue: props.switchBlankValue, // props.displayMsg === 'message'
    changedStep: {
      productSpec: false,
      spec: false,
      addon: false,
      imprintMethod: false
    }
  }
  if (props.callback) {
    props.callback(param)
  }
  emit('confirm')
  updateShow(false)
}
const onConfirm = (param: PriceGroupCallback) => {
  if (props.callback) {
    props.callback(param)
  }
  emit('confirm')
  updateShow(false)
}
</script>
